import React from 'react';
import { Reveal } from './ScrollReveal';

export default function SectionHeader({ num, eyebrow, title }) {
  return (
    <div className="flex flex-col items-center text-center mb-24 max-w-[900px] mx-auto">
      {/* Sektionsnummer als großes, dezentes Hintergrundelement */}
      <Reveal delay={0.1}>
        <div className="font-serif text-[clamp(4.5rem,12vw,8rem)] font-light text-brand-border2/20 leading-none tracking-tighter select-none -mb-8 md:-mb-12">
          {num}
        </div>
      </Reveal>
      
      <div className="relative z-10">
        <Reveal delay={0.2}>
          <div className="text-[0.75rem] font-bold tracking-[0.35em] uppercase text-brand-gold mb-6 inline-block relative px-8">
            <span className="absolute left-0 top-1/2 -translate-y-1/2 w-4 h-[1px] bg-brand-gold/40"></span>
            {eyebrow}
            <span className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-[1px] bg-brand-gold/40"></span>
          </div>
        </Reveal>
        
        <Reveal delay={0.3}>
          <h2 className="text-[clamp(2.4rem,5.5vw,4.2rem)] font-light text-brand-white tracking-tight leading-[1.1] font-serif" 
              dangerouslySetInnerHTML={{ __html: title }} />
        </Reveal>
      </div>
    </div>
  );
}